import { DataTable } from "primereact/datatable";
import { ColumnGroup } from "primereact/columngroup";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import EditIcon from "../../../../assets/pencil.png";
import RunIcon from "../../../../assets/play-circle.svg";
import ApproveIcon from "../../../../assets/check-decagram.svg";
import Button from "../../../../components/button";
import { useEffect, useState } from "react";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import DangerArrowUpSm from "../../../../assets/up-arrow-sm-danger.svg";
import WarnArrowUpSm from "../../../../assets/up-arrow-sm-warn.svg";
import {
  Error_MESSAGE,
  REBATE_INFORMATION,
  rebateInformation,
  USER_ROLE,
  VOLUME_ALLOCATION,
} from "../../../../utils/constants";
import { excelRound, numberFormatter, numberFormatterForDecimalInMNew } from "../../../../utils/formatter";
import {
  AllocationData,
  AllocationSummaryData,
  AllocationUpdatePayload,
  RebateData,
  RebateValue,
  SmartAllocations,
} from "../../../../services/interfaces/IVolumeAllocation";
import {
  useRecommendedVolumeAllocation,
  useUpdateMinVolumeAllocation,
  useUpdateVolumeAllocationData,
} from "../../../../react-query/hooks/HVolumeAllocation";
import { Input, Loader, Tooltip, Whisper } from "rsuite";
import { RadioButton } from "primereact/radiobutton";
import InfoOutline from "../../../../assets/info-outline.svg";
import {
  UserDetails,
} from "../../../../services/redux/reducer/user.reducer";
import { Dialog } from "primereact/dialog";
import CloseIcon from "../../../../assets/cross.svg";
import { InputTextarea } from "primereact/inputtextarea";
import { deepCompare } from "../../../../utils/helpers/mapModulesToIcon";
import { appInsights } from "../../../../router/router";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../../react-query/queryKeys";
import CustomModal from "../../../../components/custom-modal";
import { InputText } from "primereact/inputtext";
import infoIcon from "../../../../assets/info-circle-grey.svg";
type Props = {
  data: SmartAllocations;
  role: string;
  userDetails: UserDetails;
  allocationCriteria: "projected" | "estimated";
  callback: (arg: boolean) => void;
  refreshAllocationSummary: () => void;
  updateDemand: (arg: number | null) => void;
  commodity: string;
};

const AllocationSummary = ({
  data: props,
  role,
  userDetails,
  commodity,
  allocationCriteria: allocCriteria,
  callback,
  refreshAllocationSummary,
  updateDemand,
}: Props) => {
  const queryClient = useQueryClient();
  const [user_given_allocation, set_user_given_allocation] = useState<
    number | null
  >(null);
  const {
    mutate: mutateMinVolAlloc,
    isSuccess: isSuccessMinVolAlloc,
    isPostLoading,
  } = useUpdateMinVolumeAllocation();
  const {
    allocationData: data,
    isLoading,
    refetch,
  } = useRecommendedVolumeAllocation(
    props.commodity,
    props.district,
    props.is_reviewed_flag,
    props.estimated_demand,
    // user_given_allocation,
    role,
  );
  const [allocationCopy, setAllocationCopy] = useState<AllocationSummaryData>(
    {} as AllocationSummaryData,
  );
  const [
    blendedBasedOnRecommendedAllocation,
    setBlendedBasedOnRecommendedAllocation,
  ] = useState<number>(0);
  const [blendedBasedOnCustomAllocation, setBlendedBasedOnCustomAllocation] =
    useState<number>(0);
  const [incrementalSpend, setIncrementalSpend] = useState<{
    spend: number;
    percent: number;
  }>({ spend: 0, percent: 0 });
  const [validation, setValidation] = useState<{
    isValid: boolean;
    message: string;
    canApprove?: boolean | undefined;
  }>({ isValid: true, message: "" });
  const [showApprovalDialog, setShowApprovalDialog] = useState<boolean>(false);
  const [approvalCriteria, setApprovalCriteria] = useState<string>("self");
  const [approvalComment, setApprovalComment] = useState<string>("");
  const [allocationCriteria, setAllocationCriteria] = useState<
    "projected" | "estimated"
  >("projected");

  const [openEditModal, setOPenEditModal] = useState<boolean>(false);
  const {
    mutate,
    isError,
    error,
    isSuccess,
    data: resdata,
  } = useUpdateVolumeAllocationData();
  const [updateError, setUpdateError] = useState<{
    isError: boolean;
    message: string;
  }>({ isError: false, message: "" });
  const [manualLoading, setManualLoading] = useState<boolean>(false);
  const [estimatedDemand, setEstimatedDemand] = useState<number | null>(
    props.estimated_demand,
  );
  const normalizedCommodity = commodity?.toLowerCase() ?? "";
  const isSteelCommodity = normalizedCommodity.includes("steel");
  const isCopperWireCommodity = normalizedCommodity.includes("copper wire");
  const commodityDivisor = isSteelCommodity
    ? 46
    : isCopperWireCommodity
      ? 24
      : 229.2;
  const commodityFactor = isCopperWireCommodity ?  1/commodityDivisor :40000 / commodityDivisor  ; 
  const [demandValidation, setDemandValidation] = useState<{
    isValid: boolean;
    message: string;
  }>({ isValid: true, message: "" });
  const [minAllocationSum, setMinAllocationSum] = useState<any>(null);
  const [newMinAllocations, setNewMinAllocations] = useState({});
  const [reason, setReason] = useState("");
  const [minAllocError, setMinAllocError] = useState<{
    errorMessage: string;
    errorType: null | string;
  }>({
    errorMessage: "Reason Cannot be empty.",
    errorType: "",
  });

  useEffect(() => {
    setEditMode(false);
  }, [props]);

  useEffect(() => {
    setAllocationCriteria(allocCriteria);
  }, [allocCriteria]);

  useEffect(() => {
    if (resdata?.data) {
      // setManualLoading(true)
      if (isError) {
        setUpdateError({
          isError: true,
          message: "Some error occured. Please try again later !",
        });
      } else if (isSuccess) {
        setShowApprovalDialog(false);
        callback(true);
      }
      setTimeout(() => {
        setManualLoading(false);
      }, 300);
    }
  }, [resdata]);

  useEffect(() => {
    /* Calculate blended cost */
    if (Object.keys(data).length > 0) {
      // let isValid = userDetails.role_name === USER_ROLE.Lead || props.is_reviewed_flag === 0
      setValidation({ isValid: true, message: "" });
      setAllocationCopy(JSON.parse(JSON.stringify(data)));
      let minAllocaitonSum = 0;
      let minAllocationObj = data?.allocation_history?.filter((item: any) => {
        if (item.allocation_type === "Minimum") {
          return true;
        }
      });
      Object.keys(minAllocationObj[0]).map((item) => {
        if (item !== "allocation_type") {
          minAllocaitonSum = minAllocaitonSum + minAllocationObj[0][item];
        }
      });
      setMinAllocationSum(minAllocaitonSum);
      calculate(data);
    }
  }, [data?.allocation_data]);

  const calculate = (datasource: AllocationSummaryData) => {
    let blendedCostR = 0;
    let blendedCostC = 0;
    datasource.vendor_list.forEach((vendor: string) => {
      const recommended = datasource.allocation_data.filter(
        (data) => data.allocation_type === "recommended",
      )[0];
      const custom = datasource.allocation_data.filter(
        (data) => data.allocation_type === "custom",
      )[0];
      const latestQuote = datasource.allocation_history.filter(
        (data) => data.allocation_type === "LatestQuote",
      )[0];
      blendedCostR += recommended[vendor] * latestQuote[vendor];
      blendedCostC += custom[vendor] * latestQuote[vendor];
    });
    blendedCostR /= props.estimated_demand ?? props.projected_releases;
    blendedCostC /= props.estimated_demand ?? props.projected_releases;
    setBlendedBasedOnRecommendedAllocation(blendedCostR);
    setBlendedBasedOnCustomAllocation(blendedCostC);

    let incSpend =
      (blendedCostC - blendedCostR) *
      (props.estimated_demand ?? props.projected_releases) *
      commodityFactor;
    let incSpendPercent =
      (incSpend * 100) /
      (blendedCostR *
        (props.estimated_demand ?? props.projected_releases) *
        commodityFactor);
    setIncrementalSpend({ spend: incSpend, percent: incSpendPercent });
  };

  const [editMode, setEditMode] = useState<boolean>(false);
  const [key, setKey] = useState(1);

  useEffect(() => {
    set_user_given_allocation(
      allocCriteria === "estimated"
        ? props.estimated_demand
        : props.projected_releases,
    );
  }, [props.estimated_demand, props.projected_releases]);

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [editMode]);

  const recalculateAllocations = () => {
    if (
      !(
        userDetails.role_name === USER_ROLE.Lead ||
        userDetails.role_name === USER_ROLE.Manager ||
        props.is_reviewed_flag === 0
      )
    ) {
      return false;
    } else {
      const res: {
        isValid: boolean;
        message: string;
        canApprove: boolean | undefined;
      } = validateCustomAllocations();
      if (res.isValid || res.canApprove === true) {
        calculate(allocationCopy);
      }
      setValidation({
        isValid: res.isValid,
        message: res.message,
        canApprove: res?.canApprove,
      });
      return res.isValid || res.canApprove;
    }
  };

  const validateCustomAllocations = () => {
    let custom = allocationCopy.allocation_data.filter(
      (data) => data.allocation_type === "custom",
    )[0];
    let commitment = allocationCopy.allocation_history.filter(
      (data) => data.allocation_type === "Minimum",
    )[0];
    let res: any = { isValid: true, message: "", canApprove: undefined };
    let sumOfCustomAllocation = 0;
    // Check to see if minimum critera is met
    for (let vendor of allocationCopy.vendor_list) {
      sumOfCustomAllocation += custom[vendor];
      if (commitment[vendor] > custom[vendor]) {
        res.isValid = false;
        res.message = `You are not meeting the minimum commitment for ${vendor} !`;
        res.canApprove = true;
      }
    }

    if (
      (props.estimated_demand ?? props.projected_releases) !==
      sumOfCustomAllocation
    ) {
      res.isValid = false;
      res.message =
        "Please enter a valid numbers that matches total truckloads to allocate !";
      res.canApprove = false;
    }

    // Check to see if truckLoad matches allocation sum
    if (!res.isValid) {
      return res;
    }

    return res;
  };

  const updatedCustomAllocation = (
    truckLoad: number | null,
    rowdata: AllocationData,
    vendor: string,
  ) => {
    rowdata[vendor] = truckLoad ?? 0;
    const allData = allocationCopy.allocation_data;
    allData[1] = rowdata;
    setAllocationCopy({ ...allocationCopy, allocation_data: allData });
  };

  const handleApproveClick = () => {
    const isValid = recalculateAllocations();
    if (
      !isValid ||
      !(
        userDetails.role_name === USER_ROLE.Lead ||
        userDetails.role_name === USER_ROLE.Manager ||
        props.is_reviewed_flag === 0
      )
    ) {
      return;
    } else {
      // Threshold overridden to 0% (ignores VOLUME_ALLOCATION_THRESHOLD from API)
      const volumeAllocationThresholdPercent = 0;
      if (incrementalSpend.percent <= volumeAllocationThresholdPercent) {
        if (validation?.canApprove) {
          setApprovalCriteria("leadApproval");
        } else {
          setApprovalCriteria("self");
        }
      } else {
        setApprovalCriteria("leadApproval");
      }

      if (userDetails.role_name === USER_ROLE.Manager) {
        setApprovalCriteria("leadApproval");
        setShowApprovalDialog(true);
      } else if (userDetails.role_name === USER_ROLE.Lead) {
        submitRequest();
      } else {
        console.error(
          "Your role doesn't have sufficient permission to perform the action",
        );
      }
    }
  };

  const submitRequest = () => {
    let payload: AllocationUpdatePayload = {} as AllocationUpdatePayload;
    payload.allocation_data = allocationCopy.allocation_data;
    payload.vendor_list = allocationCopy.vendor_list;
    payload.district = props.district;
    payload.commodity = props.commodity;
    // payload.user_comments = approvalComment;
    if (userDetails.role_name === "Manager") {
      payload.isEditedByLead = false;
    } else {
      let valueCompare = deepCompare(
        data.allocation_data[1],
        allocationCopy.allocation_data[1],
      );
      let flag = false;
      if (
        (props?.is_reviewed_flag === 1 || props?.is_reviewed_flag === 2) &&
        !valueCompare
      ) {
        flag = true;
      }
      payload.isEditedByLead = flag;
    }
    if (
      !deepCompare(data.allocation_data[1], allocationCopy.allocation_data[1])
    ) {
      appInsights.trackEvent({
        name: `Volume Allocation: Custom allocation for truckloads changed for ${payload.district}`,
        properties: {
          description: `changing to ${JSON.stringify(
            allocationCopy.allocation_data[1],
          )} from ${JSON.stringify(data.allocation_data[1])}`,
        },
      });
    }
    payload.user_comments =
      approvalComment.length > 0 ? approvalComment : props?.user_comments || "";
    payload.requested_by = userDetails.userEmail;
    payload.incremental_spend = incrementalSpend.spend;
    payload.is_reviewed_flag = props.is_reviewed_flag;
    payload.role_name = userDetails.role_name;
    payload.user_name = localStorage?.getItem("name") ?? "";
    payload.is_approval_request = approvalCriteria !== "self";
    mutate(payload);
    setManualLoading(true);
    queryClient.refetchQueries({ queryKey: [queryKeys.businessTrend, "data"] });
    queryClient.invalidateQueries({
      queryKey: [
        queryKeys.volumeAllocation,
        "recommended allocation",
        props.commodity,
        props.district,
        props.is_reviewed_flag,
        props.estimated_demand,
      ],
    });
  };

  const calculateOnDemandUpdate = () => {
    if (allocationCriteria === "projected") {
      updateDemand(null);
      setDemandValidation({ isValid: true, message: "" });
    } else if (allocationCriteria === "estimated") {
      isDemandValid(estimatedDemand) ? updateDemand(estimatedDemand) : null;
      appInsights.trackEvent({
        name: `Volume Allocation: Estimated demand entered by user to ${estimatedDemand} TL's from a projected release of ${props.projected_releases} TL's for ${props?.district}`,
      });
    }
  };

  const compareAvgOfAllocations = (newAllocs: any, previosAllocs: any) => {
    let isError = true;
    let acceptableLimitObj: any = {};
    Object.keys(previosAllocs).forEach((key: string) => {
      if (key !== "allocation_type") {
        let seventyPerventValue = 0.7 * previosAllocs[key];
        acceptableLimitObj[key] = excelRound(seventyPerventValue, null);
      }
    });

    let finalArrayForTest = Object.keys(newAllocs);

    for (let i = 0; i < finalArrayForTest?.length; i++) {
      if (previosAllocs[finalArrayForTest[i]] <= 2) {
        isError = newAllocs[finalArrayForTest[i]] <= 2 ? false : true;
        if (isError) {
          break;
        }
      } else {
        if (
          newAllocs[finalArrayForTest[i]] <=
          acceptableLimitObj[finalArrayForTest[i]]
        ) {
          isError = false;
        } else {
          isError = true;
          break;
        }
      }
    }

    return isError;
  };

  const isDemandValid = (demand: number | null) => {
    // let min = Math.min(
    //   Math.ceil(0.7 * props.projected_releases),
    //   props.projected_releases - 1
    // );
    // let max = Math.max(
    //   Math.floor(1.3 * props.projected_releases),
    //   props.projected_releases + 1
    // );
    // if ((demand ?? 0) < min || (demand ?? 0) > max) {
    //   // Too Low
    //   setDemandValidation({
    //     isValid: false,
    //     message: `Value should be in ${min}-${max} range. Please enter a higher value.`,
    //   });
    //   return false;
    // } else if ((demand ?? 0) > max) {
    //   // Too High
    //   setDemandValidation({
    //     isValid: false,
    //     message: `Value should be in ${min}-${max} range. Please enter a lower value.`,
    //   });
    //   return false;
    // } else {
    setDemandValidation({ isValid: true, message: "" });
    return true;
    // }
  };

  const AllocationActions = () => {
    return (
      <div className="flex flex-nowrap justify-end items-center bg-white gap-2">
        <Button
          onClick={() => {
            if (editMode) {
              setAllocationCopy({
                ...allocationCopy,
                allocation_data: JSON.parse(
                  JSON.stringify(data.allocation_data),
                ),
              });
              calculate(data);
              setValidation({ isValid: true, message: "" });
            }
            setEditMode(!editMode);
          }}
          img={editMode ? "" : EditIcon}
          label={editMode ? "Reset" : "Edit"}
          className={`${checkDisabledForEdit() ? "visible" : "invisible"}`}
          bgColor="#949494"
          size="sm"
        ></Button>

        <Button
          onClick={() => {
            setEditMode(false);
            recalculateAllocations();
          }}
          disabled={checkDisabledForRun()}
          img={RunIcon}
          label="Run"
          bgColor="#62B5E5"
          size="sm"
        ></Button>
        <Button
          onClick={() => handleApproveClick()}
          img={ApproveIcon}
          label="Approve"
          bgColor="#86BC25"
          size="sm"
          disabled={checkDisabledForApprove()}
        ></Button>
      </div>
    );
  };

  const HeaderGroupForRebate = () => {
    return (
      <ColumnGroup>
        <Row>
          <Column frozen header="Rebate Summary"></Column>
          {data?.vendor_list?.map((vendor: string) => {
            return (
              <Column
                key={vendor}
                header={
                  <div className="flex min-h-[5.5vh] py-[0.4vh] gap-1 justify-center items-center text-center leading-[1.2] whitespace-normal">
                    <span>{vendor}</span>
                    {data?.contract_id_list?.[vendor] && (
                      <Whisper
                        speaker={
                          <Tooltip placement="auto">
                            {data?.contract_id_list?.[vendor]?.join(", ")}
                          </Tooltip>
                        }
                      >
                        <img
                          src={infoIcon}
                          alt="info"
                          className="w-[1.5vh] h-[1.5vh] shrink-0 cursor-pointer"
                        />
                      </Whisper>
                    )}
                  </div>
                }
              ></Column>
            );
          })}
        </Row>
      </ColumnGroup>
    );
  };

  const AllocationCellRebate = (rowdata: RebateData, vendor: string) => {
    const raw = rowdata[vendor] as RebateValue;

    if (rowdata.rebate_information === "YtdSpend" || rowdata.rebate_information === "SpendNeededForNextTier") {
      // { value, unit }
      if (typeof raw === "object" && raw !== null && "value" in raw && "unit" in raw && raw.value !== 0) {
        const v = raw as { value: number; unit: string, projectionStatus?: string };
        return (
          <span className="flex items-center gap-1">
            {v.unit === "$" && "$"}
            {numberFormatterForDecimalInMNew(v.value, 1)}
            {v.unit === "lbs" && " lbs."}

            {v.projectionStatus && <RenderIcon type={v.projectionStatus} />}
          </span>
        );
      }
      return <span>-</span>;
    }
    if (rowdata.rebate_information === "EffectiveQuote") {
      if (raw && raw !== 0) {
        return (
          <span>
            {numberFormatterForDecimalInMNew(Number(raw), 2, "$")}
          </span>
        );
      }
      return <span>-</span>;
    }

    if (rowdata.rebate_information === "CurrentNext") {
      // { current, next }
      if (typeof raw === "object" && raw !== null && "current" in raw && "next" in raw) {
        const v = raw as { current: number; next: number };
        return (
          <span>
            {v.current !== 0 ? v.current + "%" : "-"} / {v.next !== 0 ? v.next + "%" : "-"}
          </span>
        );
      }
      return <span>-</span>;
    }

    // EffectiveQuote or any plain value
    if (typeof raw === "number" || typeof raw === "string") {
      return <span>{raw}</span>;
    }

    return <span>-</span>;
  };

  const HeaderGroup = (actionButtonsRqd: boolean = false) => {
    return (
      <ColumnGroup>
        {actionButtonsRqd &&
          userDetails.userCanEditArray.includes("Volumne Allocation") && (
            <Row>
              <Column
                frozen
                header={AllocationActions}
                colSpan={(data?.vendor_list?.length ?? 0) + 1}
              ></Column>
            </Row>
          )}
        <Row>
          <Column frozen></Column>
          {data?.vendor_list?.map((vendor: string) => {
            return (
              <Column
                key={vendor}
                header={
                  <div className="flex min-h-[5.5vh] py-[0.4vh] gap-1 justify-center items-center text-center leading-[1.2] whitespace-normal">
                    <span>{vendor}</span>
                    {data?.contract_id_list?.[vendor] && (
                      <Whisper
                        speaker={
                          <Tooltip placement="auto">
                            {data?.contract_id_list?.[vendor]?.join(", ")}
                          </Tooltip>
                        }
                      >
                        <img
                          src={infoIcon}
                          alt="info"
                          className="w-[1.5vh] h-[1.5vh] shrink-0 cursor-pointer"
                        />
                      </Whisper>
                    )}
                  </div>
                }
              ></Column>
            );
          })}
        </Row>
      </ColumnGroup>
    );
  };

  const AllocationCell = (
    rowdata: AllocationData,
    vendor: string,
    edit: boolean,
  ) => {
    const rawValue = rowdata[vendor];
    const displayValue = rawValue;

    if (rowdata.allocation_type === "custom") {
      if (editMode) {
        return (
          <span className="w-full">
            <InputNumber
              maxFractionDigits={0}
              value={rawValue}
              onChange={(event: InputNumberChangeEvent) => {
                // console.log(event, rowdata, vendor);
                updatedCustomAllocation(event.value, rowdata, vendor);
              }}
              className="custom-input-number"
            />
          </span>
        );
      } else {
        return <span>{displayValue != null ? `${Number(displayValue).toLocaleString("en-US")}` : "-"}</span>;
      }
    }
    if (rowdata.allocation_type === "LatestQuote") {
      return <span>{numberFormatter(rawValue, 2, "$")}</span>;
    }
    return (
      <span>{displayValue != null ? `${Number(displayValue).toLocaleString("en-US")}` : "-"}</span>
    );
  };

  /* Dialog Elements */
  const HeaderElement = (
    <div className="flex flex-row justify-between items-start">
      <div className="flex flex-col justify-start items-start gap-2">
        <span className="font-normal text-fs16 text-[#858585] h-[3vh]">
          Volume Allocations
        </span>
        <span className="font-bold text-fs24">Allocation Approval</span>
      </div>
      <div>
        <img
          className="cursor-pointer"
          src={CloseIcon}
          onClick={() => {
            setShowApprovalDialog(false);
          }}
        ></img>
      </div>
    </div>
  );

  const FooterElement = (
    <div className="flex justify-end items-center gap-4">
      <Button
        label="Cancel"
        bgColor="#949494"
        size="md"
        onClick={() => {
          setShowApprovalDialog(false);
        }}
      ></Button>
      <Button
        label="Submit"
        bgColor="#86BC25"
        size="md"
        onClick={() => {
          submitRequest();
        }}
      ></Button>
    </div>
  );

  const checkDisabledForEstimatedDemand = (
    allocationCriteria: string,
    is_reviewed_flag: number,
  ) => {
    if (
      commodity &&
      userDetails?.userCommArray?.includes(commodity) === false &&
      !(userDetails.role_name === USER_ROLE.Lead)
    ) {
      return true;
    } else {
      return (
        allocationCriteria !== "estimated" ||
        (is_reviewed_flag > 0 && userDetails.role_name === USER_ROLE.Manager)
      );
    }
  };

  const checkDisabledForCalculate = () => {
    if (
      commodity &&
      userDetails?.userCommArray?.includes(commodity) === false &&
      !(userDetails.role_name === USER_ROLE.Lead)
    ) {
      return true;
    } else {
      return (
        props.is_reviewed_flag > 0 &&
        userDetails.role_name === USER_ROLE.Manager
      );
    }
  };

  const checkDisabledForEdit = () => {
    if (
      commodity &&
      userDetails?.userCommArray?.includes(commodity) === false &&
      !(userDetails.role_name === USER_ROLE.Lead)
    ) {
      return false;
    } else {
      return (
        userDetails.role_name === USER_ROLE.Lead ||
        userDetails.role_name === USER_ROLE.Manager ||
        props.is_reviewed_flag === 0
      );
    }
  };

  const checkDisabledForRun = () => {
    if (
      commodity &&
      userDetails?.userCommArray?.includes(commodity) === false &&
      !(userDetails.role_name === USER_ROLE.Lead)
    ) {
      return true;
    } else {
      return !(
        userDetails.role_name === USER_ROLE.Lead ||
        userDetails.role_name === USER_ROLE.Manager ||
        props.is_reviewed_flag === 0
      );
    }
  };

  const checkDisabledForApprove = () => {
    if (
      commodity &&
      userDetails?.userCommArray?.includes(commodity) === false &&
      !(userDetails.role_name === USER_ROLE.Lead)
    ) {
      return true;
    } else {
      if (
        validation?.canApprove !== undefined &&
        validation?.canApprove === true
      ) {
        return false;
      } else {
        // Managers can raise/re-raise approval repeatedly after editing inputs,
        // so they are not blocked once a request has been raised
        // (is_reviewed_flag === 1). Validity is still required.
        return (
          !validation.isValid ||
          !(
            userDetails.role_name === USER_ROLE.Lead ||
            userDetails.role_name === USER_ROLE.Manager ||
            props.is_reviewed_flag === 0
          )
        );
      }
    }
  };

  const editTableData = (editData: any) => {
    const previousData = editData.filter(
      (ele: any) => ele.allocation_type === "Minimum",
    );
    const previousDataLast3Month = editData.filter(
      (ele: any) => ele.allocation_type === "last3MonthsAvg",
    );
    return [
      { type: "Current min allocation", ...previousData[0] },
      {
        type: "Last 3 months average vendor allocation",
        ...previousDataLast3Month[0],
      },
      {
        type: "New min allocation",
        ...data.vendor_list.reduce((a: any, i: any) => {
          a[i] = null;
          return a;
        }, {}),
      },
    ];
  };

  useEffect(() => {
    if (isSuccessMinVolAlloc) {
      if (allocationCriteria === "estimated") {
        refetch();
      } else {
        if (props.projected_releases === user_given_allocation) {
          refetch();
        } else {
          set_user_given_allocation(props.projected_releases);
        }
      }
      refreshAllocationSummary();
      setReason("");
    }
  }, [isSuccessMinVolAlloc]);

  return (
    <>
      {isLoading || manualLoading ? (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.9, zIndex: 1202 }}
        />
      ) : (
        <div className="flex flex-col justify-start items-center gap-[1vh] max-h-[80vh] w-full overflow-y-auto">
          {/* Creating one flex div here to reduce the gap between two headings  */}
          {
            <div
              className={`flex flex-col justify-start items-start gap-2 bg-[#FFE4E8] rounded py-[0.5vh] self-stretch ${validation.isValid && demandValidation.isValid
                ? "invisible"
                : "visible px-[1vw]"
                }`}
            >
              {!validation.isValid && (
                <div className="flex justify-start items-center gap-2">
                  <img src={InfoOutline}></img>
                  <span className="text-fs14 font-semibold">
                    {validation.message}
                  </span>
                </div>
              )}

              {!demandValidation.isValid && (
                <div className="flex justify-start items-center gap-2">
                  <img src={InfoOutline}></img>
                  <span className="text-fs14 font-semibold">
                    {demandValidation.message}
                  </span>
                </div>
              )}
            </div>
          }

          {(props.is_reviewed_flag === 2 ? false : true) &&
            allocationCriteria == "projected" &&
            minAllocationSum > props.projected_releases ? (
            <div className="flex flex-col justify-start items-start gap-2 bg-[#FFE4E8] rounded px-[1vw] py-[0.5vh] self-stretch">
              <div className="flex justify-start items-center gap-2">
                <img src={InfoOutline}></img>
                <span className="text-fs14 font-semibold">
                  Projected Release is below total minimum requirement.
                  Therefore, recommended allocation is based on minimum
                  allocation ratios
                </span>
              </div>
            </div>
          ) : null}

          {(props.is_reviewed_flag === 2 ? false : true) &&
            allocationCriteria == "estimated" &&
            estimatedDemand !== null &&
            minAllocationSum > estimatedDemand ? (
            <div className="flex flex-col justify-start items-start gap-2 bg-[#FFE4E8] rounded px-[1vw] py-[0.5vh] self-stretch">
              <div className="flex justify-start items-center gap-2">
                <img src={InfoOutline}></img>
                <span className="text-fs14 font-semibold">
                  Estimated Demand is below total minimum requirement.
                  Therefore, recommended allocation is based on minimum
                  allocation ratios
                </span>
              </div>
            </div>
          ) : null}
          <span className="text-fs24">Volume Allocation Summary</span>

          <div className="flex justify-start items-center gap-2 extra-criteria px-[1vw]">
            <span className="flex justify-start items-center gap-0 grow">
              <RadioButton
                disabled={
                  props.is_reviewed_flag > 0 &&
                  userDetails.role_name === USER_ROLE.Manager
                }
                variant="filled"
                inputId="projected"
                className={allocationCriteria === "projected" ? "checked" : ""}
                name="allocationCriteria"
                value={allocationCriteria}
                onChange={(e) => {
                  setAllocationCriteria("projected");
                  set_user_given_allocation(props.projected_releases);
                  // setDistrictForAllocation({ ...districtForAllocation, estimated_demand: null })
                }}
                checked={allocationCriteria === "projected"}
              />
              <label
                htmlFor="projected"
                className={`text-fs16 ${props.is_reviewed_flag > 0 &&
                  userDetails.role_name === USER_ROLE.Manager
                  ? "opacity-50"
                  : ""
                  }`}
              >
                Projected Releases
              </label>
              <InputNumber
                maxFractionDigits={0}
                className="ml-2 custom-input-number"
                value={props.projected_releases}
                disabled
                suffix={commodity === "Copper Wire" ? " lbs" : "TLs"}
              ></InputNumber>
            </span>
            <span className="flex justify-start items-center gap-0 grow">
              <RadioButton
                disabled={
                  props.is_reviewed_flag > 0 &&
                  userDetails.role_name === USER_ROLE.Manager
                }
                variant="filled"
                inputId="estimated"
                className={allocationCriteria === "estimated" ? "checked" : ""}
                name="allocationCriteria"
                value={allocationCriteria}
                onChange={(e) => {
                  setAllocationCriteria("estimated");
                  if (props.estimated_demand) {
                    set_user_given_allocation(props.estimated_demand);
                  }
                }}
                checked={allocationCriteria === "estimated"}
              />
              <label
                htmlFor="estimated"
                className={`text-fs16 ${props.is_reviewed_flag > 0 &&
                  userDetails.role_name === USER_ROLE.Manager
                  ? "opacity-50"
                  : ""
                  }`}
              >
                Estimated Demand
              </label>
              <InputNumber
                maxFractionDigits={0}
                className="ml-2 custom-input-number"
                value={props.estimated_demand}
                disabled={checkDisabledForEstimatedDemand(
                  allocationCriteria,
                  props.is_reviewed_flag,
                )}
                onChange={(event) => setEstimatedDemand(event.value)}
                suffix={commodity === "Copper Wire" ? " lbs" : "TLs"}
              ></InputNumber>
            </span>
            {/* <div className="basis-[1.5vw]"> */}
            {userDetails.userCanEditArray.includes("Volumne Allocation") && (
              <Button
                className="w-[6vw]"
                disabled={checkDisabledForCalculate()}
                onClick={() => calculateOnDemandUpdate()}
                img={ApproveIcon}
                label="Calculate"
                bgColor="#86BC25"
                size="sm"
              ></Button>
            )}

            {/* </div> */}
          </div>

          <div className="w-full custom-allocation-table shadow-module-card">
            <DataTable
              value={allocationCopy.allocation_data}
              headerColumnGroup={HeaderGroup(true)}
              stripedRows
              key={key}
              rowClassName={() => "text-xs py-[1px] h-1"}
            >
              <Column
                className="w-[max(120px,10vw)]"
                frozen
                body={(rowdata) => {
                  return (
                    <span className="flex flex-nowrap font-bold min-w-max">
                      {rowdata.allocation_type === "recommended"
                        ? "Recommended Allocation"
                        : "Custom Allocation"}
                    </span>
                  );
                }}
              ></Column>
              {data.vendor_list.map((vendor: string) => {
                return (
                  <Column
                    key={vendor}
                    field={vendor}
                    body={(rowdata) =>
                      AllocationCell(rowdata, vendor, editMode)
                    }
                  ></Column>
                );
              })}
            </DataTable>
          </div>

          <div className="flex flex-nowrap gap-8">
            <div className="flex justify-start items-center gap-6">
              <span className="font-semibold text-fs16 flex flex-col flex-nowrap justify-start items-start">
                Blended Cost based on
                <br />
                <span className="text-deloitteGreen">
                  Recommended Allocation
                </span>
              </span>
              <span className="bg-[#f1f1f1] p-pd13 rounded-md text-fs16 font-bold text-[#999]">
                {numberFormatter(blendedBasedOnRecommendedAllocation, 2, "$")}
              </span>
            </div>
            <div className="flex justify-start items-center gap-6">
              <span className="font-semibold text-fs16 flex flex-col flex-nowrap justify-start items-start">
                Blended Cost based on
                <br />
                <span className="text-deloitteGreen">Custom Allocation</span>
              </span>
              <span className="bg-[#f1f1f1] p-pd13 rounded-md text-fs16 font-bold text-[#999] flex flex-nowrap gap-1">
                <img
                  hidden={
                    blendedBasedOnCustomAllocation <=
                    blendedBasedOnRecommendedAllocation
                  }
                  src={DangerArrowUpSm}
                  alt="danger"
                />
                {numberFormatter(blendedBasedOnCustomAllocation, 2, "$")}
              </span>
            </div>
          </div>

          <div className="shadow-module-card flex justify-between items-start rounded-md border border-[#bebebe] py-[1.2vh] px-[1vw] w-full">
            <span className="flex flex-col flex-nowrap justify-start items-start">
              <span className="font-bold text-fs16">Incremental Spend</span>
              <span className="text-[#858585] text-fs12 font-normal">
                Based on variation from{" "}
                <span className="font-bold">Recommended</span> vs{" "}
                <span className="font-bold">Custom</span> Allocation
              </span>
            </span>
            <span className="flex h-full self-end gap-4">
              <span className="font-normal text-fs32">
                {numberFormatter(incrementalSpend.spend, 0, "$")}
              </span>
              <span className="flex flex-nowrap justify-start items-center text-amber font-normal text-fs16">
                {numberFormatter(incrementalSpend.percent, 0)}%&nbsp;
                <img
                  hidden={incrementalSpend.percent === 0}
                  src={WarnArrowUpSm}
                  alt="warn"
                ></img>
              </span>
            </span>
          </div>

          <div className="w-full previous-allocation-table shadow-module-card">
            <DataTable
              value={data.allocation_history.filter(
                (item: any) =>
                  (item.allocation_type !== "reason" &&
                    item.allocation_type !== "last3MonthsAvg") === true,
              )}
              headerColumnGroup={HeaderGroup()}
              rowClassName={() => "text-xs py-[1px] h-1"}
              stripedRows
            >
              <Column
                className="w-[max(120px,15vw)]"
                frozen
                body={(rowdata) => {
                  const allocation_type =
                    rowdata.allocation_type as keyof typeof VOLUME_ALLOCATION;
                  return (
                    <span className="flex flex-nowrap font-bold min-w-max justify-between">
                      {VOLUME_ALLOCATION[allocation_type]}
                      {allocation_type === "LatestQuote" && (
                        <span>{data.size_trade}</span>
                      )}
                      {allocation_type === "Minimum" && (
                        <>
                          {data?.reason && (
                            <Whisper
                              speaker={
                                <Tooltip placement="auto">
                                  {data?.reason}
                                </Tooltip>
                              }
                            >
                              <img
                                className="cursor-pointer w-[2.2vh]"
                                src={infoIcon}
                                alt="info"
                              ></img>
                            </Whisper>
                          )}

                          {userDetails.userCanEditArray.includes(
                            "Volumne Allocation",
                          ) && (
                              <Button
                                onClick={() => {
                                  setOPenEditModal(true);
                                }}
                                img={EditIcon}
                                label={"Edit"}
                                className={`${checkDisabledForEdit() ? "visible" : "invisible"
                                  }`}
                                bgColor="#949494"
                                size="sm"
                              ></Button>
                            )}
                        </>
                      )}
                    </span>
                  );
                }}
              ></Column>
              {data.vendor_list.map((vendor: string) => {
                return (
                  <Column
                    key={vendor}
                    field={vendor}
                    body={(rowdata) =>
                      AllocationCell(rowdata, vendor, editMode)
                    }
                  ></Column>
                );
              })}
            </DataTable>
          </div>

          <div className="flex flex-col gap-0 w-full">
            {/* <span className="pl-2 font-bold text-fs18 italic flex flex-col flex-nowrap justify-start items-start">
              Rebate Information
            </span> */}
            <div className="w-full previous-allocation-table shadow-module-card">

              <DataTable
                value={data.rebate_information}
                headerColumnGroup={HeaderGroupForRebate()}
                stripedRows
                rowClassName={() => "text-xs py-[1px] h-1"}
              >
                <Column
                  className="w-[max(120px,15vw)]"
                  frozen
                  body={(rowdata: any) => {
                    const key = rowdata.rebate_information as keyof typeof REBATE_INFORMATION;
                    return (
                      <span className="flex flex-nowrap font-bold min-w-max justify-between">
                        {REBATE_INFORMATION[key]}
                        {key === "EffectiveQuote" && <span>{data.size_trade}</span>}
                      </span>
                    );
                  }}
                ></Column>
                {data.vendor_list?.map((vendor: string) => {
                  return (
                    <Column
                      key={vendor}
                      field={vendor}
                      body={(rowdata) =>
                        AllocationCellRebate(rowdata, vendor)
                      }
                    ></Column>
                  );
                })}
              </DataTable>
            </div>

            <ProjectionLegend />
          </div>

        </div>
      )}

      <Dialog
        draggable={false}
        visible={showApprovalDialog}
        modal
        header={HeaderElement}
        footer={FooterElement}
        style={{ width: "35vw" }}
        closable={false}
        onHide={() => {
          setShowApprovalDialog(false);
        }}
      >
        <div className="flex flex-col justify-start items-start py-[2vh] px-[1vw] gap-4 radio-criteria approval-dialog">
          <span className="text-fs16 font-normal">
            Approval required to finalize volume allocation along with supported
            reason as comment
          </span>
          <div className="flex justify-start items-center gap-2">
            <RadioButton
              variant="filled"
              inputId="leadApproval"
              className={approvalCriteria === "leadApproval" ? "checked" : ""}
              name="approvalCriteria"
              value={approvalCriteria}
              disabled={approvalCriteria === "self"}
              checked={approvalCriteria === "leadApproval"}
            />
            <label
              htmlFor="leadApproval"
              className={`text-fs16 ${approvalCriteria === "self" ? "opacity-50" : "opacity-100"
                }`}
            >
              Send Request for Approval
            </label>
          </div>

          <div className="flex flex-col justify-start items-start gap-1 w-full">
            <span className="text-fs16">
              Comment
            </span>
            <InputTextarea
              maxLength={300}
              rows={4}
              autoResize
              className="w-full p-[1vh] text-fs16"
              value={approvalComment}
              onChange={(e) => setApprovalComment(e.target.value)}
            />
            <span className="text-gray-500 self-end text-fs12">
              Max characters allowed 300
            </span>
          </div>
          <div
            className={`flex justify-start items-center gap-2 bg-[#FFE4E8] rounded px-[1vw] py-[0.5vh] self-stretch ${updateError.isError ? "visible" : "invisible"
              }`}
          >
            <img src={InfoOutline}></img>
            <span className="text-fs14 font-semibold">
              {updateError.message}
            </span>
          </div>
        </div>
      </Dialog>
      {openEditModal && (
        <CustomModal
          openModal={openEditModal}
          closeModal={() => {
            setOPenEditModal(false);
            setReason("");
            setMinAllocError({
              errorMessage: "Reason Cannot be empty.",
              errorType: "",
            });
          }}
          isloading={false}
          header={
            <span className="text-[0.9vw]">
              Minimum Cost Setting for
              <span className="text-[0.9vw] font-semibold pl-[0.75vh] text-deloitteGreen">
                {`${props.district}`}
              </span>
            </span>
          }
        >
          <div className="w-full edit-modal-table shadow-module-card">
            <DataTable
              value={[...editTableData(data.allocation_history)]}
              headerColumnGroup={
                <ColumnGroup>
                  <Row>
                    <Column
                      header={
                        <div className="flex justify-center items-center">
                          Supplier
                        </div>
                      }
                    ></Column>

                    {data.vendor_list.map((vendor: string) => {
                      return (
                        <Column
                          key={vendor}
                          header={
                            <div className="flex justify-center items-center">
                              {vendor}
                            </div>
                          }
                        ></Column>
                      );
                    })}
                  </Row>
                </ColumnGroup>
              }
            >
              <Column
                className="w-[12vw]"
                key="type"
                field="type"
                body={(rowdata) => {
                  return <span className="font-bold">{rowdata["type"]}</span>;
                }}
              ></Column>
              {data.vendor_list.map((vendor: string) => {
                return (
                  <Column
                    key={vendor}
                    field={vendor}
                    body={(rowdata) => {
                      if (rowdata.type === "Current min allocation")
                        return rowdata[vendor];
                      else if (
                        rowdata.type ===
                        "Last 3 months average vendor allocation"
                      )
                        return rowdata[vendor];
                      else if (rowdata.type === "New min allocation")
                        return (
                          <span className="w-full">
                            <InputNumber
                              key={`column-${vendor}`}
                              onChange={(e: InputNumberChangeEvent) => {
                                if (reason !== "") {
                                  setMinAllocError({
                                    errorMessage: "",
                                    errorType: null,
                                  });
                                }
                                if (reason == "") {
                                  setMinAllocError({
                                    errorMessage: "Reason cannot be empty.",
                                    errorType: "reasonEmpty",
                                  });
                                }
                                setNewMinAllocations((prevAllocations) => {
                                  const updated = {
                                    ...prevAllocations,
                                    [vendor]: e.value ?? 0,
                                  };
                                  return updated;
                                });
                              }}
                              maxFractionDigits={0}
                              className="custom-input-number bg-[white] p-0"
                            />
                          </span>
                        );
                    }}
                  ></Column>
                );
              })}
            </DataTable>
            <div className="flex border-1 mt-[2vh] ">
              <div className="font-bold text-fsCustom text-black flex-[0.2] pl-2">
                Reason<span className="text-red-500">*</span>
              </div>
              <div className="flex-[0.8] custom-textarea">
                <Input
                  style={{ fontSize: "1.9vh" }}
                  as="textarea"
                  onChange={(value) => {
                    if (value === "") {
                      setMinAllocError({
                        errorMessage: "Reason cannot be empty.",
                        errorType: "reasonEmpty",
                      });
                    } else {
                      setMinAllocError({
                        errorMessage: "",
                        errorType: null,
                      });
                    }

                    setReason(value);
                  }}
                  value={reason}
                  rows={2.5}
                  placeholder="Enter Reason"
                />
              </div>
            </div>
            <div className="mt-[1vh] md-[1vh] text-fsCustom text-center  text-red-500">
              {minAllocError?.errorMessage ? minAllocError?.errorMessage : ""}
            </div>
            <div className="flex w-full justify-center mt-[3.5vh]">
              <Button
                className="w-[6vw]"
                disabled={minAllocError?.errorType === null ? false : true}
                onClick={() => {
                  let previousMinAllocData = data.allocation_history.filter(
                    (ele: any) => ele.allocation_type === "last3MonthsAvg",
                  );
                  let sumOfPrevAllocations = 0;
                  let newSumOfAllocations = 0;
                  Object.keys(previousMinAllocData[0])?.map((item: string) => {
                    if (item !== "allocation_type") {
                      sumOfPrevAllocations =
                        sumOfPrevAllocations + previousMinAllocData[0][item];
                    }
                  });
                  let newMinAllocationObj: any = { ...newMinAllocations };
                  Object.keys(newMinAllocationObj).map((item: string) => {
                    newSumOfAllocations =
                      newSumOfAllocations + newMinAllocationObj[item];
                  });

                  // Skip the past-3-months-average threshold checks for Copper Wire for now.
                  if (!isCopperWireCommodity && newSumOfAllocations >= sumOfPrevAllocations) {
                    setMinAllocError({
                      errorMessage:
                        "Total allocated minimum truckloads exceed the past 3-month average allocation in the district. Review",
                      errorType: "totalAllocError",
                    });
                  }
                  let volError = isCopperWireCommodity
                    ? false
                    : compareAvgOfAllocations(
                      newMinAllocations,
                      previousMinAllocData[0],
                    );
                  if (volError) {
                    setMinAllocError({
                      errorMessage:
                        "Total allocated minimum truckloads exceed threshold based on past 3 months data. Please reallocate",
                      errorType: "totalAllocError",
                    });
                  } else {
                    let allocPayload = Object.keys(newMinAllocationObj).map(
                      (key: string) => {
                        let vendorObj = {
                          vendor: key,
                          minAlloc: newMinAllocationObj[key],
                        };
                        return vendorObj;
                      },
                    );
                    mutateMinVolAlloc({
                      commodity: props.commodity,
                      district: props.district,
                      reason: reason,
                      userEmail: userDetails?.userEmail,
                      minAllocationData: allocPayload ?? [],
                      role: role,
                      userName: localStorage?.getItem("name") ?? "",
                      increamentalSpend: incrementalSpend.spend,
                      allocation: user_given_allocation,
                    });
                    setOPenEditModal(false);
                    setMinAllocError({
                      errorMessage: "Reason Cannot be empty.",
                      errorType: "",
                    });
                  }
                }}
                label="Save"
                bgColor="#86BC25"
                size="md"
              ></Button>
            </div>
          </div>
        </CustomModal>
      )}
      {isPostLoading && isLoading && (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.6, zIndex: 1202 }}
        />
      )}
    </>
  );
};

const ProjectionLegend: React.FC = () => (
  <div className="flex ml-3 mt-1 items-center gap-2 text-[10px] text-gray-800">
    {/* >110% */}
    <div className="flex items-center gap-1">
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderBottom: "7px solid #2E7D32", // green
        }}
      />
      <span>Projected above 100% of max threshold</span>
    </div>

    {/* 90–110% */}
    <div className="flex items-center gap-1">
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderBottom: "7px solid #FBC02D", // yellow
        }}
      />
      <span>Projected between 90%-100% of max threshold</span>
    </div>

    {/* <90% */}
    <div className="flex items-center gap-1">
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: "4px solid transparent",
          borderRight: "4px solid transparent",
          borderTop: "7px solid #D32F2F", // red
        }}
      />
      <span>Projected less than 90% of max threshold</span>
    </div>
  </div>
);

const RenderIcon: React.FC<{ type: string }> = ({ type }) => (

  <>
    {type.toLowerCase() === 'green' && <span
      style={{
        width: 0,
        height: 0,
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderBottom: "10px solid #2E7D32", // green
      }}
    />}

    {type.toLowerCase() === "yellow" && <span
      style={{
        width: 0,
        height: 0,
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderBottom: "10px solid #FBC02D", // yellow
      }}
    />}

    {type.toLowerCase() === 'red' && <span
      style={{
        width: 0,
        height: 0,
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderTop: "10px solid #D32F2F", // red
      }}
    />}
  </>


);

export default AllocationSummary;
